import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { styles } from "src/apps/AppFlow/pages/styles";
import { Button, HeaderText, RegularText } from "src/components/v1";
import config from "src/config";
import { useMobileHeightAdjustment } from "src/hooks";
import confetti from "src/images/confetti-still.jpg";
import { createStyles } from "src/styles";

export interface SubmitConfirmationProps {
  focusRef?: Ref<HTMLDivElement>;
  onNext: () => void;
  style?: SerializedStyles;
}

const INNER_STYLES = createStyles({
  video: {
    width: "100vw",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 0,
    objectFit: "cover",
    background: "linear-gradient(0deg, #ffffff 0%, rgba(196, 196, 196, 0) 100%)",
  },
  container: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
  content: {
    zIndex: 1,
    height: "100vh",
    width: "100%",
    maxHeight: "100%",
    maxWidth: "100%",
    paddingLeft: 40,
    paddingRight: 40,
    background:
      "radial-gradient(50% 50% at 50% 50%, #FFFFFF 0%, rgba(255, 255, 255, 0.9) 40.42%, rgba(255, 255, 255, 0.2) 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  centeredContent: {
    justifyContent: "center",
    alignItems: "center",
  },
  secondParagraph: {
    marginTop: 0,
  },
});

const SubmitConfirmation = ({ onNext, style, focusRef }: SubmitConfirmationProps) => {
  const height = useMobileHeightAdjustment();
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ hash: "thankyou" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={focusRef} css={[styles.page, INNER_STYLES.container, style]}>
      <video css={[INNER_STYLES.video, { height }]} poster={confetti} playsInline autoPlay muted loop>
        <source src={`${config.s3URL.publicMedia}/confetti.mp4`} type="video/mp4" />
      </video>
      <div css={[styles.contentContainer, styles.centeredContentContainer, INNER_STYLES.content]}>
        <div css={[styles.centeredInnerHeaderContainer, INNER_STYLES.centeredContent]}>
          <HeaderText style={[styles.centeredText, styles.centeredHeader]}>Congratulations!</HeaderText>
          <RegularText paragraph style={[styles.text, styles.centeredText]}>
            You are on your way to unlocking your home equity on fairer terms.
          </RegularText>
          <RegularText paragraph style={[styles.text, styles.centeredText, INNER_STYLES.secondParagraph]}>
            We will reach out to you shortly with next steps.
          </RegularText>
        </div>
        <div css={styles.centeredButtonContainer}>
          <Button style={styles.centeredButton} onClick={onNext}>
            Back to home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(SubmitConfirmation);
